export const iconFontAwesomeMedicalHealthSquareH = (
	<i className="fa-solid fa-square-h"></i>
);
